import request from '@/axios/engineeringManager'

// 01-获取门店列表
export function getStoreList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/staff/staff_store/getStoreList',
    method: 'post',
    data
  })
}

// 02-获取员工详情
export function getStaffDetail(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/staff/staff/getStaffDetail',
    method: 'post',
    data
  })
}

// 03-切换当前门店
export function changeStore(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/staff/staff_store/changeStore',
    method: 'post',
    data
  })
}

// PM-01-工程部经理业务工作台
export function getBusinessCount(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/getBusinessCount',
    method: 'post',
    data
  })
}

// PM-02-工程部经理问题工地统计
export function getProblemSiteCount(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/getProblemSiteCount',
    method: 'post',
    data
  })
}

// PM-03-工程部经理问题类型统计
export function getProblemTypeCount(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/getProblemTypeCount',
    method: 'post',
    data
  })
}

// G-02-硬装流程订单列表
export function getProcessOrderList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/order/order/getProcessOrderList',
    method: 'post',
    data
  })
}
// G-1201-工程部通过审核提交
export function saveExamine(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/order/no_disclose/saveExamine',
    method: 'post',
    data
  })
}
// B-14-获取服务岗位员工列表
export function getStationStaffList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/base/select_option/getStationStaffList',
    method: 'post',
    data
  })
}
// J-01获取外部资源列表
export function getMemberList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/resources/resources/getMemberList',
    method: 'post',
    data
  })
}
// S-01-获取消息列表
export function getMessageLists(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/message/getMessageList',
    method: 'post',
    data
  })
}

// A-05-我的工地
export function mySite(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/mySite',
    method: 'post',
    data
  })
}
// S-03-读取消息
export function readMessageInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/message/readMessageInfo',
    method: 'post',
    data
  })
}

// pm-06-进程播报
export function messageList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/messageList',
    method: 'post',
    data
  })
}

// pm-07-我的服务团队
export function getServiceTeam(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/getServiceTeam',
    method: 'post',
    data
  })
}
// S-05-更新消息为已读状态
export function updateMessageStatus(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/message/updateMessageStatus',
    method: 'post',
    data
  })
}

// A-05-我的工地
export function getSiteList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/workbench/project_manager/getSiteList',
    method: 'post',
    data
  })
}

// F-v2-播报-获取播报列表
export function getMessageListApi(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/message/getMessageList',
    method: 'post',
    data
  })
}

// E-客诉处理-02-获取待处理客诉列表
export function getComplaintList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/complaint/getComplaintList',
    method: 'post',
    data
  })
}
// 08-获取交付部门列表(new)
export function getDepartmentList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/base/select_option/getDepartmentList',
    method: 'post',
    data
  })
}
// D-02新增编辑项目经理列表(new)
export function saveManagerMember(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/resources/resources/saveManagerMember',
    method: 'post',
    data
  })
}
// D-03获取项目经理列表(new)
export function getManagerMemberList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/resources/resources/getManagerMemberList',
    method: 'post',
    data
  })
}
// D-04获取项目经理详情(new)
export function getManagerMemberInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/resources/resources/getManagerMemberInfo',
    method: 'post',
    data
  })
}
// 07-获取交付公司列表(new)
export function getCompanyList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/base/select_option/getCompanyList',
    method: 'post',
    data
  })
}
// 09-切换交付公司(new)
export function changeCompany(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/base/select_option/changeCompany',
    method: 'post',
    data
  })
}
// B-获取施工变更列表
export function getAlterationList(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/construction_alteration/getAlterationList',
    method: 'post',
    data
  })
}
